export const columns = {
  dragHandle: { width: 46, flex: '0 0 auto', justifyContent: 'center' },
  riskBands: { width: 142, flex: '0 0 auto' },
  model: { flex: 1 },
  riskScore: { width: 120, flex: '0 0 auto', justifyContent: 'center' },
  actions: { width: 64, flex: '0 0 auto', justifyContent: 'flex-end' },
};
